module.exports = __webpack_public_path__ + "static/img/Banner_600x300_monogenic-disease.a395047.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/reproductive/Banner_600x300_monogenic-disease.jpg
// module id = 3leM
// module chunks = 0